<template>
    <Layout>
        <PageHeader :title="title" :items="items" :backButton="true" :prevRoutePath="backUrl"/> 
        <div class="row">
            <div class="col-lg-12 col-sm-12 mb-3">
                <div class="card p-4">
                    <div class="media">
                        <div class="avatar-sm mr-3">
                            <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                                <i class="bx bx-world bx-md"></i>
                            </span>
                        </div>
                        <div class="media-body">
                            <h5 class="mt-3">{{ $t('website.website-cms-detail') }}</h5>
                        </div>
                    </div>
                    <div>
                        <div class="row mt-1">
                          <!-- <p>
                                {{SearchResult}}
                            </p> -->
                            <div class="col-sm-12">
                                  <hr>
                                    <div class="text-center p-5" v-if="loading">
                                        <div class="spinner-border text-secondary" role="status" v-if="loading">
                                        <span class="sr-only"><p>{{ $t('website.website-cms-detail') }}</p></span>
                                    </div>
                                </div>
                            </div>
                             <div class="col-sm-12" >
                              <label v-if="cms"><b>Cms:</b></label>
                                  <p v-for="(data, index) in  JSON.parse(cms)" :key="index">
                                    <span> {{data.name}}: <span class="text-success">{{data.categories}}</span></span>
                                  </p>
                                
                              <label v-if="JSON.parse(sm)[0]" class="mt-3"><b>{{ $t('website.social_media') }}:</b></label>
                                   <p v-for="(data, index) in  JSON.parse(sm)" :key="index">
                                      <span> {{data.network}}: <a :href="data.url" target="_blank" rel="noopener noreferrer" class="text-success"> [ {{data.profile}} ]</a></span>
                                    </p>             
                            </div>
                        </div>
                    </div>
                   </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import WebsiteService from "@/helpers/website.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Tools Website",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            backUrl: "/cms-checker",
            id: this.$route.params.id,
            urlimage: 'http://localhost:8001/api/target/image-project?name=',
            loading: false,
            cms: "",
            sm:"",
            dataResult: {
            },
            search:false,
            title: this.$t('website.website-cms-detail'),
            items: [
                {
                text: "Dashboard",
                href: "/"
                },
                {
                text: this.$t('website.website-cms-checker'),
               href: "/cms-checker"
                },
                {
                text: this.$t('website.website-cms-detail'),
                active: true
                }
            ],
        }
    },
    methods:{
        getWebsiteCmsDetail(){
        this.loading = true;
          WebsiteService.getWebCmsDetail(this.id)
          .then(response => {
                    // console.log(response);
                    this.dataResult = response.data.data;
                    this.cms = response.data.data.result;
                    this.sm = response.data.data.social_media;
                    this.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = flase;
            });
        },
      formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },
  },
    mounted(){
        this.totalRows = this.items.length;
        this.getWebsiteCmsDetail();
    }
};
</script>

<style scoped>
.loading{
    padding-top:20%;
    padding-bottom:20%;
}
</style>